import { Loader2 } from "lucide-react";

export const FIT_RATINGS = [
  { k: "strong", label: "Strong fit", on: "bg-[#166534] text-white border-[#166534]", chip: "bg-[#166534]/10 text-[#166534]" },
  { k: "maybe", label: "Maybe", on: "bg-[#FFCB05] text-[#15233B] border-[#FFCB05]", chip: "bg-[#FFCB05]/30 text-[#7a5a1a]" },
  { k: "not_fit", label: "Not a fit", on: "bg-[#b91c1c] text-white border-[#b91c1c]", chip: "bg-[#b91c1c]/10 text-[#b91c1c]" },
];

export function FitChip({ rating }) {
  const r = FIT_RATINGS.find((x) => x.k === rating);
  return (
    <span data-testid={`fit-chip-${rating || "none"}`} className={`inline-flex items-center text-[9px] font-extrabold uppercase tracking-[0.12em] px-1.5 py-0.5 rounded ${r ? r.chip : "bg-[#1E73C9]/10 text-[#1E73C9]"}`}>
      Resume review{r ? ` · ${r.label}` : ""}
    </span>
  );
}

export default function ResumeNotes({ draft, setDraft, notes, saving, onSave, writable }) {
  const hasDraft = !!(draft.rating || draft.body.trim());
  return (
    <div data-testid="resume-notes" className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#15233B]/60">First impressions</div>
      {writable && (
        <>
          <div className="flex flex-wrap gap-1.5">
            {FIT_RATINGS.map((r) => (
              <button key={r.k} type="button" data-testid={`resume-fit-${r.k}`}
                onClick={() => setDraft((d) => ({ ...d, rating: d.rating === r.k ? null : r.k }))}
                className={`px-2.5 py-1 rounded-full text-[11px] font-bold border transition-colors ${draft.rating === r.k ? r.on : "border-[#15233B]/15 text-[#15233B]/65 hover:border-[#15233B]/40"}`}>
                {r.label}
              </button>
            ))}
          </div>
          <textarea data-testid="resume-note-input" rows={3} value={draft.body} onChange={(e) => setDraft((d) => ({ ...d, body: e.target.value }))}
            placeholder="Quick thoughts — experience, gaps, red flags… (@mention a teammate)"
            className="w-full border border-[#15233B]/15 rounded px-2.5 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#1E73C9]/30" />
          <button data-testid="resume-note-save" type="button" disabled={!hasDraft || saving} onClick={onSave}
            className="w-full flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md border border-[#1E73C9]/40 text-[#1E73C9] text-xs font-bold hover:bg-[#1E73C9]/10 disabled:opacity-40">
            {saving && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Save note
          </button>
        </>
      )}
      <div data-testid="resume-notes-list" className="space-y-2 pt-1">
        {notes.length === 0 && <div className="text-[11px] italic text-[#15233B]/45">No resume notes yet.</div>}
        {notes.map((n) => (
          <div key={n.id} data-testid={`resume-note-${n.id}`} className="border border-[#15233B]/10 rounded-md px-2.5 py-2 bg-[#F6F3EC]/60">
            <div className="flex items-center gap-1.5 flex-wrap">
              <FitChip rating={n.rating} />
              <span className="text-[10px] text-[#15233B]/50">{n.author_name} · {new Date(n.created_at).toLocaleDateString()}</span>
            </div>
            {n.body && <div className="text-xs text-[#15233B]/85 whitespace-pre-wrap break-words mt-1">{n.body}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
